export const workoutDraftKey = (userId: string): string => "vyv_active_workout:" + userId;

/** Explicit deletion may target a legacy or corrupt cache that cannot restore.
 * A fresh ID never authorizes deletion of another live durable checkpoint. */
export function workoutDraftRetirementClientId(raw: string | null, fallbackId: string): string {
  try {
    const value = raw === null ? null : JSON.parse(raw) as { clientId?: unknown };
    const candidate = value?.clientId;
    if (typeof candidate === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(candidate)) return candidate;
  } catch { /* Explicit exact-byte removal also supports a malformed cache. */ }
  return fallbackId;
}
